import { HashRouter, Switch, Route } from 'react-router-dom';

import { ManageUsers } from './components/ManageUsers/index.jsx';
import AllUsers from './components/AllUsers';
import { Audiences } from '../boardSetup/components/Audiences.jsx';
import PopulationSegments from '../boardSetup/components/PopulationSegments.jsx';

const ClientAdminUsers = () => {
  return (
    <HashRouter hashType="noslash">
      <Switch>
        <Route exact path="/">
          <ManageUsers />
        </Route>
        <Route path="/all-users">
          <AllUsers />
        </Route>
        <Route path="/population-segments">
          <PopulationSegments />
        </Route>
        <Route path="/audiences">
          <Audiences />
        </Route>
      </Switch>
    </HashRouter>
  );
};

export default ClientAdminUsers;
